(() => {
  const initializeProtection = () => {
    const root = document.documentElement;
    const enabled = root.dataset.copyProtection === 'true';
    const blockTextCopy = document.body.classList.contains('wm-no-select');

    if (!enabled && !blockTextCopy) return;

    document.addEventListener('contextmenu', (event) => {
      if (!enabled) return;
      if (event.target.closest('img, picture, svg, video, .wm-copy-protected')) {
        event.preventDefault();
      }
    });

    document.addEventListener('dragstart', (event) => {
      if (enabled && event.target.closest('img, picture, svg, video')) {
        event.preventDefault();
      }
    });

    document.addEventListener('selectstart', (event) => {
      if (blockTextCopy && !event.target.closest('input, textarea, select, [contenteditable="true"]')) {
        event.preventDefault();
      }
    });

    document.addEventListener('copy', (event) => {
      if (blockTextCopy && !event.target.closest('input, textarea, [contenteditable="true"]')) {
        event.preventDefault();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!blockTextCopy) return;
      const key = event.key.toLowerCase();
      if ((event.ctrlKey || event.metaKey) && ['c', 'x', 's', 'u', 'p'].includes(key)) {
        event.preventDefault();
      }
    });

    document.querySelectorAll('img').forEach((image) => {
      image.setAttribute('draggable', 'false');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProtection, { once: true });
  } else {
    initializeProtection();
  }
})();
